import { NgModule } from '@angular/core';
import { META_REDUCERS, StoreModule } from '@ngrx/store';
import { userReducer } from '@store/reducers/user.reducers';
import { storageMetaReducer } from '@store/meta/store-meta-reducer';
import { EffectsModule } from '@ngrx/effects';
import { UserEffects } from '@store/effects/user.effects';
import { StorageService } from '@core/services/storage/storage.service';
import { appReducer } from './reducers/app.reducers';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '@env/environment';
import { homeReducer } from '@store/reducers/home.reducers';
import { HomeEffects } from '@store/effects/home.effects';
import { MasterEffects } from '@store/effects/master.effects';
import { masterReducer } from '@store/reducers/master.reducers';
import { recentInputReducer } from '@store/reducers/recent-input.reducer';
import { NotificationsEffects } from './effects/notifications.effects';
import { notificationsReducer } from './reducers/notifications.reducer';
import { authReducer } from '@store/reducers/auth.reducers';
import { AuthEffects } from '@store/effects/auth.effects';
import { consumptionReducer } from '@store/reducers/consumption.reducer';
import { ConsumptionEffects } from '@store/effects/consumption.effects';
import { alertsReducer } from '@store/reducers/alerts.reducers';
import { AlertsEffects } from './effects/alerts.effects';
import { SustainabilityEffects } from './effects/sustainability.effects';
import { sustainabilityReducer } from './reducers/sustainability.reducers';
import { myServicesReducer } from './reducers/my-services.reducers';
import { MyServicesEffects } from './effects/my-services.effects';
import { myInvoicesReducer } from './reducers/my-invoices.reducer';
import { MyInvoicesEffects } from './effects/my-invoices.effects';
import { proceduresListingReducer } from '@store/reducers/procedures-listing.reducer';
import { ProceduresListingEffects } from '@store/effects/procedures-listing.effects';
import { languageReducer } from '@store/reducers/language.reducers';
import { LanguageEffects } from '@store/effects/language.effects';
import { BillingReportEffects } from './effects/billing-report.effects';
import { RecentInputEffects } from '@store/effects/recent-input.effects';
import { spendingTrendsReducer } from '@store/reducers/spending-trends.reducer';
import { SpendingTrendsEffects } from '@store/effects/spending-trends.effects';

@NgModule({
  imports: [
    StoreModule.forRoot({
      app: appReducer,
      user: userReducer,
      home: homeReducer,
      master: masterReducer,
      recentInput: recentInputReducer,
      notifications: notificationsReducer,
      auth: authReducer,
      consumption: consumptionReducer,
      alerts: alertsReducer,
      sustainability: sustainabilityReducer,
      myServices: myServicesReducer,
      myInvoices: myInvoicesReducer,
      proceduresListing: proceduresListingReducer,
      language: languageReducer,
      spendingTrends: spendingTrendsReducer,
    }),
    EffectsModule.forRoot([
      UserEffects,
      HomeEffects,
      MasterEffects,
      NotificationsEffects,
      AuthEffects,
      ConsumptionEffects,
      BillingReportEffects,
      AlertsEffects,
      RecentInputEffects,
      SustainabilityEffects,
      MyServicesEffects,
      MyInvoicesEffects,
      ProceduresListingEffects,
      LanguageEffects,
      SpendingTrendsEffects,
    ]),
    StoreDevtoolsModule.instrument({
      // Retains last 25 states
      maxAge: environment.env === 'prod' ? 5 : 50,
      // Restrict extension to log-only mode
      logOnly: environment.env === 'prod',
      // Pauses recording actions and state changes when the extension window is not open
      autoPause: true,
      trace: environment.env !== 'prod',
    }),
  ],
  exports: [StoreModule],
  providers: [
    {
      provide: META_REDUCERS,
      multi: true,
      useFactory: storageMetaReducer,
      deps: [StorageService],
    },
  ],
})
export class NgRxStoreModule {}
